export default __webpack_public_path__ + "static/media/service-thumb-precast-steps.3ad0a22c.jpg";